import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ButtonModule } from 'primeng/button'
import { CardLayoutModule } from '../shared/card-layout/card-layout.module'
import { CookieDisabledPageComponent } from './cookie-disabled-page/cookie-disabled-page.component'
import { FeedbackRoutingModule } from './feedback-routing.module'
import { NetworkErrorPageComponent } from './network-error-page/network-error-page.component'
import { Page404Component } from './page404/page404.component'
import { SessionExpiredPageComponent } from './session-expired-page/session-expired-page.component'
import { FeedbackPageComponent } from './shared/feedback-page/feedback-page.component'
import { GenericErrorPageComponent } from './generic-error-page/generic-error-page.component'
import { SvgIconsModule } from '../shared/svg-icons/svg-icons.module'

@NgModule({
  declarations: [
    FeedbackPageComponent,
    CookieDisabledPageComponent,
    Page404Component,
    NetworkErrorPageComponent,
    GenericErrorPageComponent,
    SessionExpiredPageComponent,
  ],
  imports: [CommonModule, FeedbackRoutingModule, CardLayoutModule, ButtonModule, SvgIconsModule],
})
export class FeedbackModule {}
